module.exports = __webpack_public_path__ + "img/sld_mfm_dark.8cb2a8a7.svg";